<template>
  <textarea
    :id="id"
    :value="value"
    :name="name"
    :placeholder="placeholder"
    :required="required"
    :style="`${noResize ? 'resize: none;' : ''}`"
    class="autoFocus tw-flex tw-w-full tw-items-start tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[13px] tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]"
    :autofocus="!value ? true : false"
    :class="`${className} ${validation?.$error ? 'error' : ''}`"
    @blur="
      () => {
        validateOnBlur && validation?.$touch && validation.$touch();
        $emit('blur');
      }
    "
    @focusout="$emit('focusout')"
    @focus="$emit('focus')"
    @input="(e: any) => $emit('update:value', e.target.value)"
  />
  <b-form-invalid-feedback :class="{ 'is-invalid': validation.$error }">
    <VRuntimeTemplate :template="validation?.$errors?.[0]?.$message" />
  </b-form-invalid-feedback>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import VRuntimeTemplate from "vue3-runtime-template";

@Component({
  components: {
    VRuntimeTemplate,
  },
  emits: ["focusout", "focus", "update:value", "blur"],
})
export default class TextArea1 extends Vue {
  @Prop({ required: false, default: "" }) readonly placeholder: string = "";
  @Prop({ required: false, default: "" }) readonly id: string = "";
  @Prop({ required: false, default: "" }) readonly name: string = "";
  @Prop({ required: false, default: false }) readonly required: boolean = false;
  @Prop({ required: false, default: false }) readonly noResize: boolean = false;
  @Prop({ required: false }) value: any = "";
  @Prop({ required: false, default: "" }) className: any = "";
  @Prop({ required: false, default: false }) readonly validateOnBlur: boolean =
    false;
  @Prop({ required: false, default: () => ({}) }) readonly validation: any = {};
}
</script>

<style scoped>
textarea {
  background: rgba(239, 240, 241, 0.5);
  font-family: "Poppins";
  outline: none;
}

textarea::placeholder {
  color: #b7b7b7;
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.error {
  border: 1px solid var(--ui-rule, red);
  background: #fee5e2;
}
</style>
